<div id="toast-container" [@messageTrigger]="messageState">
    <div *ngIf="statusMessage" class="toast toast-{{statusMessage.status.text}}">
        <div class="toast-message">
            {{statusMessage.statusText}}
        </div>
    </div>
</div>